import apiClient, { extractData, handleApiError } from './api.js';

export class TableService {
  /**
   * Create a new table (auto-numbered)
   * POST /api/v1/tables
   */
  static async createTable(outletId) {
    try {
      const response = await apiClient.post('/tables', { outlet_id: outletId });
      return extractData(response);
    } catch (error) {
      console.error('Error creating table:', error);
      throw new Error(handleApiError(error));
    }
  }

  /**
   * Get all tables for an outlet
   * GET /api/v1/tables?outlet_id=...
   */
  static async getTables(outletId) {
    try {
      const response = await apiClient.get('/tables', {
        params: { outlet_id: outletId },
      });
      const data = extractData(response);
      return data.tables || data || [];
    } catch (error) {
      console.error('Error fetching tables:', error);
      throw new Error(handleApiError(error));
    }
  }

  /**
   * Deactivate a table
   * DELETE /api/v1/tables/{tableId}
   */
  static async deleteTable(tableId) {
    try {
      const response = await apiClient.delete(`/tables/${tableId}`);
      return extractData(response);
    } catch (error) {
      console.error('Error deleting table:', error);
      throw new Error(handleApiError(error));
    }
  }

  /**
   * Get table status (Public - no auth)
   * GET /api/v1/tables/status?outlet_slug=...&table_number=...
   */
  static async getTableStatus(outletSlug, tableNumber) {
    try {
      const response = await apiClient.get('/tables/status', {
        params: { outlet_slug: outletSlug, table_number: tableNumber },
      });
      return extractData(response);
    } catch (error) {
      console.error('Error fetching table status:', error);
      throw new Error(handleApiError(error));
    }
  }

  /**
   * Free a table manually
   * PATCH /api/v1/tables/{tableId}/free
   */
  static async freeTable(tableId) {
    try {
      const response = await apiClient.patch(`/tables/${tableId}/free`);
      return extractData(response);
    } catch (error) {
      console.error('Error freeing table:', error);
      throw new Error(handleApiError(error));
    }
  }
}
